import styles from "./index.css";
import PropTypes from "prop-types";
import content from "app-content";
import classnames from "classnames";

export const SellingFastBadge = ({
  labelledById,
  isProductSellingFast,
  className
}) =>
  isProductSellingFast ? (
    <div
      id={labelledById}
      aria-label={content.va_selling_fast_label}
      aria-hidden={true}
      className={classnames(styles.sellingFastBadge, className)}
    >
      {content.selling_fast_label}
    </div>
  ) : null;

SellingFastBadge.propTypes = {
  labelledById: PropTypes.string.isRequired,
  isProductSellingFast: PropTypes.bool,
  className: PropTypes.string
};
